module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerRoman-ee01dca6b276f0b20154ef84b61c9c17.eot";